// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import formatRadioCurvePoints from './formatRadioCurvePoints'

const formatRadioCurveSet = radioCurveSet => dispatch => {
  const {
    filterReferenceCode,
    radioCurvePoints,
    radioCurveSetId,
  } = radioCurveSet

  const curves = dispatch(formatRadioCurvePoints(radioCurvePoints))

  // takes the first curve type that was assigned as the initial selected value.
  const curvesSetDisplayed = Object.keys(curves)[0]

  return {
    curvesSetDisplayed,
    curves,
    filterReferenceCode,
    radioCurveSetId,
  }
}

export default formatRadioCurveSet
